
$( document ).ready(function() {

    // quick add to cart 
    // Delegate click event to the body
    $(document).on('click', function (e) {
      // Check if the event target is a link inside a '.size-swatch_link' parent
      if ($(e.target).closest('.size-swatch_link').length || $(e.target).hasClass('size-swatch_link')) {
        e.preventDefault();
        var swatch_link;
        if($(e.target).closest('.size-swatch_link').length){
          var swatch_link = $(e.target).closest('.size-swatch_link')
          
          var id = $(e.target).closest('.size-swatch_link').attr('data-id');
        }else{
          var swatch_link = $(e.target);
          var id = $(e.target).attr('data-id');
        }
        swatch_link.addClass('loading');
        // Extract the variant ID from the href attribute of the clicked link
        // Prepare the data object for the AJAX request
        var data = {
          id: id,
          quantity: 1 // Adjust the quantity as needed
        };
    
        // Perform the AJAX request to add the item to the cart
    
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: async function (response) {
                try {
                  // If the response is successful
                  if (response) {
                    // Check if cart page or cart section type is active
                    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
                      return window.location.href = `${Shopify.routes.root}cart`;
                    }
            
                    // Fetch updated cart content
                    const cartContent = await fetch(`${Shopify.routes.root}cart.js`).then(res => res.json());
                    cartContent["sections"] = response["sections"];
    
                    // Dispatch custom event to notify variant was added
                    document.dispatchEvent(new CustomEvent("variant:add", {
                      bubbles: true,
                      detail: {
                        items: response.hasOwnProperty("items") ? response["items"] : [response],
                        cart: cartContent
                      }
                    }));
            
                    // Dispatch a cart change event
                    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                      bubbles: true,
                      detail: {
                        baseEvent: "variant:add",
                        cart: cartContent
                      }
                    }));
                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                      bubbles: true
                    }));
                   swatch_link.removeClass('loading');
                    
                    
                  } else {
                    // Handle error response by dispatching a custom event with error description
                    document.dispatchEvent(new CustomEvent("cart:error", {
                      bubbles: true,
                      detail: {
                        error: response["description"]
                      }
                    }));
                  }
                } catch (error) {
                  // Handle any errors during the process
                  alert("An error occurred while updating the cart: " + error.message);
                }
              },
              error: function (xhr) {
                // Handle the AJAX error and alert the user
                alert("Error: " + xhr.responseJSON.description);
              }
            });
    
      }
    }); 

    $(".klaviyo-bis-close").on("click", function () {
    $("#BIS_container").hide();
  });
  $("#BIS_trigger").on("click", function () {
    $("#BIS_container").toggle();
  });

  // toggle country list
  $(".iti__selected-flag").on("click", function () {
    $(".iti__selected-flag .iti__arrow").toggleClass('iti__arrow--up');
    $(".iti__country-list").toggleClass('iti__hide');
  });
  
  $('.iti__country').each(function() {
      $(this).on('click', function() {
          // Remove the existing .iti__selected-flag div
          $(".iti__selected-flag .iti__flag").remove();
  
          // Find and clone the new flag element
          let newFlag = $(this).find('.iti__flag').clone();
  
          // Append the new flag inside the correct container
          $(".iti__flag-container  .iti__selected-flag").prepend(newFlag);


          // update attr
          $(".iti__selected-flag").attr('data-country-code', $(this).attr('data-country-code'))
          $(".iti__selected-flag").attr('data-dial-code', $(this).attr('data-dial-code'))
          //update css class
          $(".iti__country-list").addClass('iti__hide');
          $(".iti__selected-flag .iti__arrow").removeClass('iti__arrow--up');
        
      });
  });
  if(  document
    .getElementById("back-in-stock-form")){
    
  document
    .getElementById("back-in-stock-form")
    .addEventListener("submit", function (e) {
      e.preventDefault();

      const email = document
        .getElementById("back-in-stock-form")
        .querySelector("input#email").value;
      let phone = document
        .getElementById("back-in-stock-form")
        .querySelector("input#phone").value;
      const dial = document
        .querySelector(".iti__selected-flag").getAttribute('data-dial-code');
      //error message
      if (!email && !phone) {
        $("#back-in-stock-form .banner-error_1").css('display','flex');
        return;
      }
      let dial_phone = '+' + dial + phone;
      $("#back-in-stock-form .banner-error_1").hide();
      const product_id = document
        .getElementById("back-in-stock-form")
        .querySelector("#variants").value;
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          revision: "2024-06-15",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: [],
              profile: {
                data: {
                  type: "profile",
                  attributes: {},
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${product_id}`,
                },
              },
            },
          },
        }),
      };

      // Validate email
      if (email) {
        options.body = JSON.parse(options.body); // Parse body to object
        options.body.data.attributes.channels.push("EMAIL");
        options.body.data.attributes.profile.data.attributes.email = email;
        options.body.data.attributes.profile.email = email;
      }

      // Validate phone (basic check for digits only)
      if (phone) {
        options.body =
          typeof options.body === "string"
            ? JSON.parse(options.body)
            : options.body;
        options.body.data.attributes.channels.push("SMS");
        options.body.data.attributes.profile.data.attributes.phone_number =
          dial_phone;
        
        options.body.data.attributes.profile.phone_number = dial_phone;
      }

      // Convert body back to string
      options.body = JSON.stringify(options.body);

      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VQtbef",
        options
      )
        .then((response) => {
          if (response.status === 202) {
            $("#completed_message").show();
            $("#BIS_container .content_container").hide();
            setTimeout(() => {
                $("#BIS_container").hide();
                $("#completed_message").hide();
                $("#BIS_container .content_container").show();
            },5000);
            
          } else {
            $("#error_message").css('display','flex');

          }
        })
        .catch((err) => console.error(err));
    });
    }

//product quick add
  $(document).on(
    "click",
    ".product-quick-add [data-option-selector]",
    function (e) {
      // e.preventDefault();
      var target = e.target;
      var value = $(
        '.product-quick-add [data-option-selector] [name="option1"]:checked'
      ).val();
      // $(`.product-info__variant-picker variant-picker [name="option1"][value="${value}"]`).prop('checked', true);
      var currentScroll = $(window).scrollTop();
      $(
        `.product-info__variant-picker variant-picker [name="option1"][value="${value}"]`
      )
        .next()
        .trigger("click");
      $(window).scrollTop(currentScroll);

      $(".product-quick-add [data-option-selector]").css("display", "none");
      $(".product-quick-add .select-size").css("display", "none");
      $(".product-quick-add buy-buttons").css("display", "block");
    }
  );
    // quick add
  $(document).on(
    "click",
    "product-quick-add buy-buttons button.disabled",
    function (e) {
      e.preventDefault();
      // Scroll to the element
      // show the select size text
      // if($('.variant-picker__option .error').length <= 0){
      //   $('.variant-picker__option').prepend('<p class="error">Please select your size: </p>');
      // }
      $("html, body").animate(
        {
          scrollTop: $("variant-picker").offset().top - 200,
        },
        1000
      ); // 1000 ms = 1 second
    }
  );
    // charm
    $(document).on('click', '.product-alt-charms label' ,function(e) {
        $('.product-alt-charms label.selected').removeClass('selected');
        $(this).addClass('selected');
      
    });
      $(document).on('click', '.ProductSelector.charms label.productSelector_label' ,function(e) {
        $('.Charms.product-info__accordion').attr('open', '');
        $('.Charms.product-info__accordion').attr('aria-expanded', true);
        
        $('.Charms.product-info__accordion .accordion__content').css('opacity', '1');
        $('#charm')[0].scrollIntoView();
    });
  // quick add
  $(document).on('click', 'product-quick-add buy-buttons button.disabled' ,function(e) {
    e.preventDefault();
      // Scroll to the element
    // show the select size text
    // if($('.variant-picker__option .error').length <= 0){
    //   $('.variant-picker__option').prepend('<p class="error">Please select your size: </p>');
    // }
    $('html, body').animate({
      scrollTop: $('variant-picker').offset().top - 200
    }, 1000); // 1000 ms = 1 second
  });
  
  // change promotion on resize
  $(window).resize(function() {
    $('.grid-product__tag.grid-product__tag--hand_beaded.promotion svg').each(function( index ) {
        $(this).css({
          width: $(this).closest('.product-card__figure').height()*0.7
        });
      $(this).show();
    });
  });
    $('.grid-product__tag.grid-product__tag--hand_beaded.promotion svg').each(function( index ) {
        $(this).css({
          width: $(this).closest('.product-card__figure').height()*0.7
        });
      $(this).show();
      
    });



  //faq page
  if ($(".faq_page .faq_container").length > 0) {
    // hide faq content on mobile
    var newWindowWidth = $(window).width() * 1;

    $(document).on("click", ".faq_container button", function (e) {
      $(".faq_content").show();
      $(".faq_container .active").removeClass("active");
      $(this).addClass("active");
      var target = $(this).attr("data-target");
      target = $(`#${target}`);
      $('.faq_container [data-active="true"]').attr("data-active", "false");
      target.attr("data-active", "true");
      // mobile'
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 699) {
        $(".faq_container .faq_nav").hide();
        $(".mobile_title button").text($(this).text());
        $(".mobile_title").show();
      }
    });
    
    //open all accordions on desktop
    if ($(window).width() > 789) { // Only run if screen width is greater than 789px
      $('.accordion-title').each(function(){
        $(this).attr('open','');
      })
      
    }
    $(document).on("click", ".mobile_title svg", function (e) {
      $(document).on("click", ".mobile_title svg", function (e) {
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 699) {
          $(".faq_container .faq_nav").show();
          $(".mobile_title").hide();
          $(".faq_content").hide();
        }
        //  if($('.faq_container button.active').prev().prop("tagName") === 'BUTTON'){
        //    var prev = $('.faq_container .active').prev();
        //    $('.faq_container .active').removeClass('active');
        //    prev.addClass('active');
        //    var target = $('.faq_container .active').attr('data-target');
        //  }else{
        //    $('.faq_container .active').removeClass('active');
        //    $('.faq_container button').last().addClass('active');
        //    var target = $('.faq_container button').last().attr('data-target');
        //  }
        // target = $(`#${target}`);
        //  $('.faq_container [data-active="true"]').attr('data-active', 'false');
        //  target.attr('data-active', 'true');
      });
      //  if($('.faq_container button.active').prev().prop("tagName") === 'BUTTON'){
      //    var prev = $('.faq_container .active').prev();
      //    $('.faq_container .active').removeClass('active');
      //    prev.addClass('active');
      //    var target = $('.faq_container .active').attr('data-target');
      //  }else{
      //    $('.faq_container .active').removeClass('active');
      //    $('.faq_container button').last().addClass('active');
      //    var target = $('.faq_container button').last().attr('data-target');
      //  }
      // target = $(`#${target}`);
      //  $('.faq_container [data-active="true"]').attr('data-active', 'false');
      //  target.attr('data-active', 'true');
    });
  }
  //checkout button
  // $(document).on('click', 'cart-drawer .buy-buttons [type="submit"]' ,function(e) {
    
  //   $('cart-drawer .buy-buttons [type="submit"]').css('display', 'flex');
  // }); 
  // sticky add to cart
  // if($('.product-quick-add [data-option-selector]').length > 0){
  //   var sourceHtml = $('.product-info__variant-picker variant-picker [data-option-selector]').html();

  // // Add the source HTML to the target element
  // $('.product-quick-add [data-option-selector]').html(sourceHtml);
  // }
  $(document).on('click', '.select-size' ,function(e) {
  $('.product-quick-add [data-option-selector]').css('display', 'flex');
  });
  $(document).on('click', '.product-quick-add [data-option-selector]' ,function(e) {
    // e.preventDefault();
  var target = e.target;
  var value = $('.product-quick-add [data-option-selector] [name="option1"]:checked').val();
  // $(`.product-info__variant-picker variant-picker [name="option1"][value="${value}"]`).prop('checked', true);
    var currentScroll = $(window).scrollTop();
  $(`.product-info__variant-picker variant-picker [name="option1"][value="${value}"]`).next().trigger('click'); 
        $(window).scrollTop(currentScroll);

  $('.product-quick-add [data-option-selector]').css('display', 'none');
  $('.product-quick-add .select-size').css('display', 'none');
  $('.product-quick-add buy-buttons').css('display', 'block');
});
  // Auto slide announcement bar
   setInterval(() => {
     if($('html:not(.lock):not(.lock_popup) .announcement-bar [is="next-button"]')){
       $('html:not(.lock):not(.lock_popup) .announcement-bar [is="next-button"]').trigger('click');
     }
    }, 5000);
  //sort by
  // Function to toggle the popover
    function togglePopover() {
        var $popover = $('.sort-by-facet .popover');
        $popover.toggleClass('open');
    }
    
    // Function to close the popover
    function closePopover() {
      
        var $popover = $('.sort-by-facet .popover');
        $popover.removeClass('open');
    }
    
    // Attach click event to toggle the popover
    $(document).on('click', '.sort-by-facet .text-with-icon', function (e) {
        e.stopPropagation(); // Prevent click event from bubbling up
        togglePopover();
    });
    
    // Attach click event to close the popover when clicking outside of it
    $(document).on('click','facet-sort-by', function (e) {
        var $popover = $('.sort-by-facet .popover');
    
      
        if (!$(e.target).closest('.sort-by-facet').length) {
          
            closePopover();
        }
    });
  // click image on product page
  $(document).on('click','.product-gallery__media[data-media-type="image"]', function () {
    $('.product-images-zoom .is-selected').removeClass('is-selected');
  var get_image_id = $(this).attr('data-media-id');
    var target = $(`.product-images-zoom [data-bloom-media-id='${get_image_id}'`);
    target.addClass('is-selected');
    $('.product-images-zoom').addClass('is-active');
    
  });
  $(document).on('click','.product-images-zoom ', function () {
    $('.product-images-zoom').removeClass('is-active');
  });
  //zoom in on mobile
    // filter swatches
  if ($(window).width() < 20000) {
  $('.product-alt-colours.enable_slider').slick({
    slidesToShow: 9,
    slidesToScroll: 2,
    autoplay: false,
    prevArrow: '<div class="slick-prev"><svg role="presentation" focusable="false" width="8" height="10" viewBox="0 0 7 10"><path d="M6 1 2 5l4 4" fill="none" stroke="currentColor" stroke-width="2"></path></svg></div>',
    nextArrow: '<div class="slick-next"><svg role="presentation" focusable="false" width="8" height="10"  viewBox="0 0 7 10"><path d="m1 9 4-4-4-4" fill="none" stroke="currentColor" stroke-width="2"></path> </svg></div>'
  });
  } ;
  $('.custom-arrows .custom-right').on('click', function(e){
    var total_amount =  $('.product-gallery__thumbnail-list .product-gallery__thumbnail').length;
      var current_select = $('.product-gallery__thumbnail-list [aria-current="true"]').attr('data-index') * 1;
    if(current_select !== total_amount){
      if($(this).hasClass('disabled')){
          $(this).removeClass('disabled');
      }
      
       var next = current_select + 1; 
      var target = ".product-gallery__thumbnail-list [data-index='" + next + "']";
      $(target).click();
    }else{
      $(this).addClass('disabled');
    }
  });
    $('.custom-arrows .custom-left').on('click', function(e){
    var total_amount =  $('.product-gallery__thumbnail-list .product-gallery__thumbnail').length;
      var current_select = $('.product-gallery__thumbnail-list [aria-current="true"]').attr('data-index') * 1;
    if(current_select !== 1){
      if($(this).hasClass('disabled')){
          $(this).removeClass('disabled');
      }
       var next = current_select - 1; 
      var target = ".product-gallery__thumbnail-list [data-index='" + next + "']";
      $(target).click();
    }else{
      $(this).addClass('disabled');
    }
  });
  $('.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('tab-active');
    content = $(active.attr('data-hf'));
    links.not(':first').each(function () {
      $($(this).attr('data-hf')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('tab-active');
      content.hide();
      active = $(this);
      content = $($(this).attr('data-hf'));
      active.addClass('tab-active');
      content.show();
      return false;
    });
  });

  $(document).on('change', '.size-chart-dropdown', function(){

    var gcountry = $('#c_select_box').val().replace('/','') || 'Australia';
    var sid = $(this).attr('id');    
    if(sid == 'in-cm_select_box'){}
    else{
      if(gcountry == 'Australia'){
        $('#in-cm_select_box').val('cm');
      }
      else{
        $('#in-cm_select_box').val('in');    
      }
    }

    $('.cntry').hide();
    var country = $('#c_select_box').val().replace('/','');
    var lenght = $('#in-cm_select_box').val().replace('/','');
    $('#' + country+lenght).show();
  });

  if($('body').hasClass('template-page')){
        if($("#c_select_box").length > 0){
    var gcountry = $('#c_select_box').val().replace('/','') ;
    if(gcountry == 'Australia'){
      $('#in-cm_select_box').val('cm').trigger('change');
    }
    $('.tab-link[data-type="swim"]').trigger('click');
        }
  }
  $(".size-guide").on('click', function() {
    $(".size-chart-wrap .custom-model-main").addClass('model-open');
    $('body').addClass('overlay-active');

    var gcountry = $('#c_select_box').val().replace('/','');
    if(gcountry == 'Australia'){
      $('#in-cm_select_box').val('cm').trigger('change');
    }

    var type = $(this).data('size');
    if(type){
      $('.tab-link[data-type="'+type+'"]').trigger('click');
    }
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $('body').removeClass('overlay-active');
    $('.sg-tabs').removeClass('tab-active');
    $('.tab-link').removeClass('tab-active');
  });
  
  $(document).on('click', '[add-to-cart]', function(e){
    e.preventDefault();
    var vid = $(this).attr('data-id');
    var qty = 1;
    addUpsellToCart(vid,1, '_gift');
  });
  $(document).on('click', '.cartdu_add', function(e){
    e.preventDefault();
    $(this).prop('disabled', true);
    $(this).text('adding');
    
    setTimeout(() => {
      var vid = $(this).closest('.cartdu_form').find('[name="id"]').val();
      var qty = 1;
      if($(this).attr('checked')){
        $(this).prop( "checked", false);
         if($(`line-item[data-id='${vid}']`).length > 0){
           $(`line-item[data-id=${vid}] .link`)[0].click();
         }
           return
        
      }else{
        $(this).prop( "checked", true);
      }
  
       addUpsellToCart(vid,1, '_upsell');
    }, 500);
  });
  //Toggle product shipping protection 
  $(document).on('click', '[data-shipping-protection="true"] .js-qty__adjust--minus', function(e){
    $('#easy-protection').click();
  })
  
  
  document.addEventListener('line-item:change', function(evt) {
    var cart = evt.detail.cart;
    if(cart.item_count > 0){
      var items = cart.items;
      
      var hasupsell = false;
      for (i = 0; i < items.length; i++) {
        var upprop = items[i].properties['_upsell'];
        
        if(upprop == 'yes'){
          hasupsell = false;
        }        
      } 
      
      if(hasupsell){}
      else{
        $('.cartd_upsell_main').show();
      }
      
    }
    
    
  });

 
  // Pre Order Code starts
  $(document).on('click', '.variant__button-label', function() {
    var handle = $(this).attr('data-handle')
    setTimeout(function(){ 
      var varId = $('.product-single__variants').find('option:selected').attr('data-order');
      var valuee = $('.preod_prop').data('value');
      var prop = $('.preod_prop').data('prop');
      
      var dispatch_date_text  = $('.product-single__variants').find('option:selected').data('dispatch-date');
      var pro_dispatch  = $('.dispatch-pre-order-notice-pdp').data('dispatch');
      if(dispatch_date_text){
        $('.dispatch-pre-order-notice-pdp .dispatch_span').html(dispatch_date_text);
        $('.preod_123').val(dispatch_date_text);
      }
      else{
        $('.dispatch-pre-order-notice-pdp .dispatch_span').html(pro_dispatch);
        $('.preod_123').val(pro_dispatch);
      }
      if (varId === 'true') {
        $('.pre-order-notice-pdp').css("display", "block");
        $('.dispatch-pre-order-notice-pdp').css("display", "none");
        $(".add-to-cart span").text("Add to Cart");
        $('.preod_prop').val(valuee);
        $('.preod_prop').attr('name', prop);      
      }
      else{
        $('.pre-order-notice-pdp').css("display", "none");
        $('.dispatch-pre-order-notice-pdp').css("display", "block");
        $('.preod_prop').val('');
        $('.preod_prop').attr('name', '');
      }
    }, 10);
  });

  // Pre Order Code ends
  
  
    $('.grid-product a.grid-product__link').click(function(e){
    if($(window).width() < 767){
      
      if($(this).hasClass('grid_link_open')){       
      }
      else{
        e.preventDefault();
        $(this).addClass('grid_link_open');
      }
      
    }
  });
  
  $('.grid-product__link').click(function(){
    var url = $(this).data('link');
    window.location.href = url;
  });
  
  // Open the footer accordion when subscribed
  if(window.location.href.indexOf('customer_posted=true#newsletter-footer') > -1|| window.location.href.indexOf('form_type=customer#newsletter-footer') > -1){
    setTimeout(() => {
      $('footer [data-type="newsletter"] .collapsible-trigger-btn').click();
        $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    }, 1500);
  }

  // Open the complete the set 
  $('#product-upsell_btn').trigger('click');

  // filter
  if ($(window).width() < 768) {
    // Function to toggle the popup
function togglePopup() {
    $('html').toggleClass('lock');

    $('.collection__facets').toggleClass('open');
    $('.collection__facets-overlay').toggleClass('open');
}

// Function to close the popup
function closePopup() {
    $('html').removeClass('lock');
    $('.collection__facets').removeClass('open');
    $('.collection__facets-overlay').removeClass('open');
}

// Attach touch event to toggle the popup
$(document).on('click', '.collection__top-bar .filter', function (e) {
    e.preventDefault(); // Prevent default touch behavior
    togglePopup();
});

// Attach touch event to close the popup when clicking outside of it
$(document).on('click', function(e) {
  if($('.collection__facets.open').length > 0){
    
    if (!$(e.target).closest('.collection__facets').length && !$(e.target).closest('.filter').length) {
        closePopup();
    }
    
    if ($(e.target).closest('[is="close-button"]').length || $(e.target).attr('is') == 'close-button') {
        closePopup();
    }
  }
    
});
    
  } ;

  $('.prodretail ul').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
   arrows: false 
});
    // Function to set the height of thumbnails on pdp
  function setElement2Height() {
    var productGalleryHeight = $('.product-gallery__ar-wrapper').height();
    $('.product-gallery--desktop-thumbnails-left .product-gallery__thumbnail-list').css('max-height',productGalleryHeight);
    $('.product-gallery--desktop-thumbnails-left .product-gallery__thumbnail-list').css('width',productGalleryHeight);
  }

  // Set the height on page load
    setElement2Height();

  // Set the height when the window is resized
  $(window).resize(function() {
    setElement2Height();
  });

});

function addUpsellToCart(uid, uqty, property) {
  if(property === "_upsell"){
      data = {
        "id": uid,
        "quantity": uqty,
        "properties": {
          "_upsell": "yes",
        }
      }
  }else{
          data = {
      "id": uid,
      "quantity": uqty,
      "properties": {
        "_gift": "yes",
      }
      }
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) { 

      //new theme.CartDrawer();
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true
      }));
      $('.cart_free_gift').hide();


      
    },
    error: function(response){
      alert(response.responseJSON.description);
    }
  });

}

